import {HistoryListType} from '../../../domain/history/type';
import {MainTabItemType} from '../MainTab/MainTabItemType.interface';

export const WARNING_REMAIN_DAYS = 2;

export const CASH_TAB_ITEMS: MainTabItemType[] = [
  {
    id: HistoryListType.Buy,
    text: '충전내역',
    textTKey: 'cash_history_added_tab',
    href: `/history/cash?tab=${HistoryListType.Buy}`,
  },
  {
    id: HistoryListType.Use,
    text: '사용내역',
    textTKey: 'cash_history_used_tab',
    href: `/history/cash?tab=${HistoryListType.Use}`,
  },
];
